import { put, select, takeLatest } from 'redux-saga/effects'
import { IOption, IOptionObj } from '../../../common/common.types'
import { getSignatureOptionsSelector } from '../../options/selectors'
import { setCutomSignatureTranformedOptions } from '../../options/store/options.actions'
import { OptionsConstants } from '../../options/store/options.constants'
import { ISignatureOptionsState } from '../../options/store/options.types'
import Logger from '../../../services/logger.service'

export function* setCustomSignatureTransformedOptions() {
  try {
    const signatureOptionsState: ISignatureOptionsState = yield select(getSignatureOptionsSelector)
    const { customSignatureOptions, customSignatureTypeOptions } = signatureOptionsState
    const finalDataForPickList: { id: number; name: string; values: IOptionObj[]; text: string }[] = []
    if (customSignatureOptions.length > 0 && customSignatureTypeOptions.length > 0) {
      customSignatureOptions.forEach((mainData) => {
        if (mainData.defineLevel) {
          const subArray: any = []
          mainData.text &&
            mainData.text.split('|').forEach((dt: string) => {
              if (dt.startsWith('$') && !dt.startsWith('$pt') && !dt.startsWith('$PR')) {
                const fetchId = parseInt(dt.replaceAll('$', ''))

                if (fetchId < 0) {
                  const temp = {
                    id: fetchId,
                    name: dt.split(':')[1].replaceAll('$', ''),
                    parentName: mainData.name,
                    parentID: mainData.id,
                    textInfoRequired: mainData.textInfoRequired,
                  }
                  subArray.push(temp)
                } else {
                  const sigType = customSignatureTypeOptions.filter((signType: IOption) => signType.id === fetchId)[0]
                  if (sigType) {
                    const temp = {
                      ...sigType,
                      parentName: mainData.name,
                      parentID: mainData.id,
                      textInfoRequired: mainData.textInfoRequired,
                    }
                    subArray.push(temp)
                  }
                }
              }
            })

          if (subArray.length > 0) {
            const cunstomSignatureTypeTranformedOptions = {
              id: mainData.id,
              name: mainData.name,
              values: subArray,
              text: mainData.text,
            }
            finalDataForPickList.push(cunstomSignatureTypeTranformedOptions)
          }
        }
      })
    }
    yield put(setCutomSignatureTranformedOptions(finalDataForPickList))
  } catch (e) {
    Logger.error(`setCustomSignatureTransformedOptions() error: ${e}`)
  }
}
export function* setCustomSignatureTransformedOptionsSaga() {
  yield takeLatest(
    [OptionsConstants.SET_CUSTOM_SIGNATURE_TYPE_OPTIONS, OptionsConstants.SET_CUSTOM_SIGNATURE_OPTIONS],
    setCustomSignatureTransformedOptions
  )
}
